import { createDefaultQuoteAddress, IQuoteAddress, prettyAddress } from './IQuoteAddress';
import { createDefaultQuoteTransaction, IQuoteTransaction, prettyTransaction } from './IQuoteTransaction';

export interface IQuote {
  lender_id?: string;
  id: string | null;
  address: IQuoteAddress;
  transactionInformation: IQuoteTransaction;
}

export const createDefaultQuote = (): IQuote => ({
  id: null,
  address: createDefaultQuoteAddress(),
  transactionInformation: createDefaultQuoteTransaction(),
});

export const prettyQuote = {
  id: 'ID',
  address: prettyAddress,
  transactionInformation: prettyTransaction,
};
